export default "__VITE_ASSET__FYu11LwJ__"